<template>
  <div v-if="authenticated" class="Home">
    <!-- Towel Reservation Component -->

    <div class="Home__diverse">
      <diverse-slider data-v-step="1"></diverse-slider>
    </div>

    <towel-reservation></towel-reservation>
    <hyrox-reservation v-if="false"></hyrox-reservation>

    <div>
      <payment-home @foundOpenPayments="openPayments = true"></payment-home>
    </div>

    <v-row no-gutters>
      <v-col v-if="false" cols="12" class="d-flex mb-2 mt-5">
        <v-btn color="#90c8df" @click="$router.push('/alibey')" class="mx-auto white--text"> Jetzt Sportwoche buchen </v-btn>
      </v-col>
      <v-col v-if="showParty" cols="12" class="d-flex mt-2 mb-4 justify-center">
        <v-btn x-large @click="$router.push('/party')" class="party-glitter-btn white--text font-weight-black">
          <v-icon left>mdi-party-popper</v-icon>
          Anmeldung zur Party
        </v-btn>
      </v-col>
      <v-col v-if="buelachStudio" cols="12" class="d-flex mb-2 mt-5" style="place-content: center">
        <google-feedback-dialog></google-feedback-dialog>
      </v-col>
    </v-row>

    <div v-if="!alibeyStudio && !hideMyTraining" class="Home__training">
      <my-training data-v-step="0"></my-training>
    </div>

    <membercard
      v-if="user && user.membercard"
      :firstName="user.vorname"
      :email="user.email"
      @hideTraining="hideMyTraining = true"
      :membercard="user.membercard"></membercard>
    <router-view></router-view>

    <router-link v-if="tendays_date != null && tendays_date > 0 && !user.abo" to="/membercard" tag="div" class="link">
      <div class="membercard-wrapper">
        <div class="countdown-wrapper">
          <span class="time_left">Verbleibende Zeit</span>
          <vue-countdown :time="tendays_date" v-slot="{ days, hours, minutes, seconds }" class="countdown">
            <div class="tage">
              <span class="up">
                {{ days }}
              </span>
              <span class="down">TAGE</span>
            </div>
            <div class="stunden">
              <span class="up">
                {{ hours }}
              </span>
              <span class="down">STUNDEN</span>
            </div>
            <div class="minuten">
              <span class="up">
                {{ minutes }}
              </span>
              <span class="down">MINUTEN</span>
            </div>
            <div class="sekunden">
              <span class="up">
                {{ seconds }}
              </span>
              <span class="down">SEKUNDEN</span>
            </div>
          </vue-countdown>
        </div>

        <span class="mcard-span">MEMBERCARD</span>
      </div>
    </router-link>

    <div class="Home__groupFitness pb-5 mb-10">
      <next-courses-home data-v-step="2"></next-courses-home>
    </div>
    <alibey-popup></alibey-popup>
    <black-week-teaser></black-week-teaser>
    <rebranding-info></rebranding-info>
  </div>
</template>

<script>
import api from "../api"

import nextCoursesHome from "../components/gf/nextCoursesHome.vue"

import myTraining from "../components/training/myTraining.vue"

import diverseSlider from "../components/home/diverseSlider.vue"
import alibeyPopup from "@/views/aliBey/alibeyPopup.vue"
import VueCountdown from "@chenfengyuan/vue-countdown"
import membercard from "@/components/home/membercard.vue"
import userService from "../services/userService"
import googleFeedbackDialog from "@/components/home/googleFeedbackDialog.vue"
import TowelReservation from "@/components/TowelReservation.vue" // Import the new component
import HyroxReservation from "@/components/HyroxReservation.vue" // Import the new component
import BlackWeekTeaser from "@/views/einmalig/BlackWeekTeaser.vue"
import RebrandingInfo from "@/components/home/rebrandingInfo.vue"

import { mapState, mapActions, mapGetters } from "vuex"
export default {
  name: "Home",
  components: {
    googleFeedbackDialog,
    VueCountdown,
    diverseSlider,
    TowelReservation,
    HyroxReservation,
    nextCoursesHome,
    alibeyPopup,
    myTraining,
    BlackWeekTeaser,
    membercard,
    RebrandingInfo,
  },
  data() {
    return {
      userService,

      hideMyTraining: false,
      openPayments: false,

      tendays_date: null,
      showParty: false,
    }
  },
  watch: {
    // Watcher, um tendays_date zu berechnen, sobald der User aus dem Store geladen ist
    user(newUser) {
      if (newUser && newUser.tendays_date) {
        const startDate = new Date(newUser.tendays_date * 1000)
        const endDate = new Date(startDate.setDate(startDate.getDate() + 10))
        const now = new Date()
        this.tendays_date = endDate - now
      }
      if (newUser?.consent1 && !this.navigationVisible) {
        this.toggleNavigationBarVisibility()
      }
    },
  },

  async created() {
    this.setSelectedNavigation(null)
    this.setSelectedNavigation("home")

    if (localStorage.getItem("token")) {
      if (!localStorage.getItem("pushToken") && window.flutter_inappwebview) {
        //|| this.checkTime(localStorage.getItem('initPushCooldown')) > 23
        if (!localStorage.getItem("initPushCooldown")) {
          this.$emit("showPushPopUp")
        }
      }
      this.$emit("checkPopup")
      this.$emit("checkVersion")
      this.$emit("fetchNotifications")
      this.setNavigationBarText(null)

      this.setNewBottomNavigationUsage(null)
    }

    let party = await api.fetchSignupAvailabilityParty()

    if (party.isEmployee && party.visible) {
      this.showParty = true
    }
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),
    ...mapState("userStore", ["user"]),
    local() {
      return location.host.includes("local")
    },
    alibeyDate() {
      let now = this.$moment().unix() * 1000
      let end = this.$moment("2024-12-06 23:59").unix() * 1000

      return end - now
    },
    alibeyStudio() {
      return this.user && this.user.studio_id === "alibey"
    },
    buelachStudio() {
      return this.user && this.user.studio_id === "buelach"
    },

    authenticated() {
      if (localStorage.getItem("token")) return true
      return false
    },
    roodyGeneral() {
      if (location.host.includes("wellcomefit") || location.host.includes("localhost") || location.host.includes("wintifit")) return true
      return false
    },
  },

  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText", "setNewBottomNavigationUsage", "toggleNavigationBarVisibility"]),

    ...mapActions("navigationStore", ["setSelectedNavigation"]),

    pushToReferralRoute() {
      this.$router.push("/referral")
      /* if (
        this.user &&
        (this.user.email === 'dominic.ammann.ch@gmail.com' ||
          this.user.email === 'sebs@wellcomefit.ch' ||
          this.user.email === 'tk@wellcomefit.ch' ||
          this.user.email === 'jw@wellcomefit.ch' ||
          this.user.email === 'kn@wellcomefit.ch')
      ) {
        this.$router.push('/einstein/contest')
      } else {
        this.$router.push('/intern/referral')
      } */
    },

    checkTime(item) {
      var currentTime = this.$moment()
      var timeStore = this.$moment(item.created)

      return currentTime.diff(timeStore, "h")
    },
  },
}
</script>

<style lang="scss" scoped>
.countdownAlibey {
  display: flex;
  flex-direction: row;
  width: 305px;
  margin: auto;
  justify-content: center;
  align-items: center;

  .date {
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    text-align: center;

    .up {
      font-weight: bold;
      font-size: 28px;
    }

    .down {
      font-size: 11px;
      text-transform: uppercase;

      letter-spacing: 1.1px;
    }
  }
}

.membercard-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  position: relative;

  .countdown-wrapper {
    margin: auto 0 0 0;
    position: absolute;
    top: 0px;
    display: flex;
    flex-direction: column;
    width: 100%;

    .time_left {
      text-transform: uppercase;
      font-weight: bold;
      color: #fff;
      padding: 5px 0px 5px 0px;
      font-size: 13px;
      letter-spacing: 2px;
      text-align: center;
      background-color: #ff9800;
      margin-bottom: 7px;
    }

    .countdown {
      display: flex;
      flex-direction: row;
      width: 305px;
      margin: auto;

      > div {
        margin: 10px;
        display: flex;
        flex-direction: column;
      }

      span.up {
        text-align: center;
      }

      span.down {
        font-size: 13px;
        font-weight: bold;
      }
    }
  }

  .mcard-span {
    margin: auto;
    padding-top: 100px;
  }
}

.section {
  position: relative;
}

.tag {
  display: flex;
  justify-content: space-between;

  .tag_title {
    font-size: 18px;
    letter-spacing: 0.5px;
  }

  .tag_subtitle {
    font-size: 14px;
    margin: auto 0px;
  }

  span {
    font-weight: bold;
  }
}

.Home {
  &__diverse {
    width: 91.666%;
    margin: 0 auto;
  }

  &__greeting {
    display: block;
    position: relative;

    &-gift {
      position: absolute;
      right: 0;
      top: 0;
    }

    &-referral {
      height: 110px;
      width: 160px;
      background-size: contain;
      background-image: url(/img/kampagne/refer/referAFriend100.png);
      position: absolute;
      top: 0px;
      right: 0px;
    }

    &-subtitle {
      color: black !important;
      letter-spacing: 1px;
      font-weight: bold;
      padding-bottom: 0px;
    }

    &-title {
      letter-spacing: 1px;
      padding-top: 0px;
      display: block;
      font-weight: bold;

      &-training {
        color: orange;
      }
    }
  }
}

@keyframes shimmerAnim {
  0% {
    transform: translateX(-150%) skewX(-20deg);
  }
  100% {
    transform: translateX(150%) skewX(-20deg);
  }
}

.party-glitter-btn {
  // Grundlegendes Layout & Form
  width: 95%; // Etwas Abstand zum Rand
  max-width: 400px; // Nicht zu breit auf großen Screens
  border-radius: 50px !important; // Pillenform für modernen Look
  height: auto !important; // Damit Padding wirkt
  padding: 16px 24px !important;
  border: none !important;

  // Typografie
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 1.2rem !important;

  // Positionierung für die Effekte
  position: relative;
  overflow: hidden; // Wichtig, damit der Schimmer nicht rausläuft
  transition: all 0.3s ease-in-out;

  // Schatten für Tiefe
  box-shadow: 0 5px 15px rgba(212, 33, 33, 0.4);

  // DER HINTERGRUND-VERLAUF (Die Basis)
  // Ein tiefer, reicher Verlauf von Rot zu Gold/Orange
  background: linear-gradient(
    135deg,
    rgba(4, 81, 37, 1) 0%,
    // Tiefrot
    #0d9842ff 50%,
    // Knallrot
    #3ca453ff 100% // Gold-Orange
  ) !important;

  // Hover-Effekt: Leichtes Vergrößern und mehr Schatten
  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 8px 25px rgba(7, 53, 17, 0.6);
  }

  // PSEUDO-ELEMENT 1: DIE GLITZER-PARTIKEL TEXTUR
  // Wir simulieren Glitzer mit winzigen Punkten über dem Verlauf
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3; // Nur subtil sichtbar
    z-index: 0;
    // Ein CSS-Muster aus kleinen Gold- und Weiß-Punkten
    background-image: radial-gradient(circle at center, rgba(53, 120, 2, 0.8) 1px, transparent 1px, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
    background-size: 4px 4px; // Sehr feines Muster
  }

  // PSEUDO-ELEMENT 2: DER WANDERNDE "SHINE" EFFEKT
  &::after {
    content: "";
    position: absolute;
    top: -50%;
    left: 0;
    width: 60%;
    height: 200%;
    opacity: 0.7;
    z-index: 1;
    // Ein weißer, schräger Lichtbalken
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 100%);
    // Die Animation anwenden
    animation: shimmerAnim 3s infinite cubic-bezier(0.4, 0, 0.2, 1);
  }

  ::v-deep .v-btn__content {
    position: relative;
    z-index: 2;
    // Ein leichter Schatten, damit der weiße Text auf dem hellen Gold gut lesbar bleibt
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  }
}
</style>
